import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 18l18 -12h-18l9 14l9 -14v10l-18 -10l0 12","key":"svg-0"}]]

const IconBrandDcos = createReactComponent('outline', 'brand-dcos', 'BrandDcos', __iconNode);

export default IconBrandDcos;